import type { UploadFile } from 'antd';
import { DoneFileUpload, ErrorFileUpload, FileUploading } from './status-components';

type P = {
  file: UploadFile;
  removeUpload: () => void;
  retryUpload: () => void;
};

const UploadFileList = ({ file, removeUpload, retryUpload }: P) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  switch (file.status) {
    case 'done':
      return <DoneFileUpload fileName={file.name} removeUpload={removeUpload} />;
    case 'error':
      return <ErrorFileUpload fileName={file.name} removeUpload={removeUpload} retryUpload={retryUpload} />;
    case 'uploading':
      return <FileUploading fileName={file.name} percent={file.percent ?? 0} removeUpload={removeUpload} />;
    default:
      return null;
  }
};

export default UploadFileList;
